﻿import { TabStrip, TabStripTab } from '@progress/kendo-react-layout';
import { useCallback, useState } from 'react';
import { useEvent } from '../../../../contexts/event-bus';
import { HomeFlyoutTypes } from '../types';
import IconRingsSettings from './IconRingsSettings';
import { LayersNavState } from './LayersFlyout.types';
import PlaneSettings from './PlaneSettings';
import TagSettings from './TagSettings';
import { CityPairSettings } from './CityPairSettings';

export default function AircraftSettings() {
    const [selectedTab, setSelectedTab] = useState(0);

    useEvent(
        'open-flyout',
        useCallback((args) => {
            if (args.type === HomeFlyoutTypes.layers && args.sub?.type === LayersNavState.AircraftSettings && args.sub.sub != undefined) {
                setSelectedTab(args.sub.sub);
            }
        }, [])
    );
    return (
        <div className="h-100 min-h-0 d-flex flex-column" style={{ width: '535px' }}>
            <TabStrip
                selected={selectedTab}
                onSelect={(e) => setSelectedTab(e.selected)}
                className="h-100 min-h-0 remove-padding flight-details-tab-bar"
                animation={false}>
                <TabStripTab title="Aircraft">
                    <PlaneSettings />
                </TabStripTab>

                <TabStripTab title="Tags">
                    <TagSettings />
                </TabStripTab>

                <TabStripTab title="Icon/Rings">
                    <IconRingsSettings />
                </TabStripTab>

                <TabStripTab title="City pair">
                    <CityPairSettings />
                </TabStripTab>
            </TabStrip>
        </div>
    );
}
